import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-12162a84"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "feature-wrap pt-20 pb-20 myfeature" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "goal-content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "content-title style1 mb30" }, [
    /*#__PURE__*/_createElementVNode("span", null, "SOLUTIONS"),
    /*#__PURE__*/_createElementVNode("h2", null, [
      /*#__PURE__*/_createTextVNode(" Nos Solutions "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" Digitales ")
    ])
  ])
], -1))
const _hoisted_4 = { class: "row justify-content-left" }
const _hoisted_5 = { class: "feature-card style3" }
const _hoisted_6 = { class: "feature-info" }
const _hoisted_7 = { class: "feature-title" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "sous-titre" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.articles, (article, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-xl-4 col-lg-6 col-md-6",
            key: index
          }, [
            _createVNode(_component_router_link, {
              to: { name: 'ViewArticlePage', params: { id: article.id } },
              class: "link style1 db"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("span", null, [
                        _createElementVNode("img", {
                          src: _ctx.getUrlApiForFiles(article.urlImage),
                          alt: "Image"
                        }, null, 8, _hoisted_8)
                      ]),
                      _createElementVNode("h3", null, _toDisplayString(_ctx.truncateText(article.titre,15)), 1)
                    ]),
                    _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.truncateText(article.sousTitre, 40)), 1)
                  ])
                ])
              ]),
              _: 2
            }, 1032, ["to"])
          ]))
        }), 128))
      ])
    ])
  ]))
}